<template lang="pug">
	.web-services--script-builder--popup
		Popup(v-if="popupVisible", :popupVisible.sync="popupVisible", :width="1280", :autosize="true")
			ScriptBuilder(v-if="popupVisible", ref="builder", :source="source", :scriptInfo.sync="scriptInfo", :service="service", :params="params")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Save', '@actions')", @click="save", type="default")
				DxButton(:text="$tCaption('Close', '@actions')", @click="popupVisible = false")
</template>

<script>
import ScriptBuilder from './ScriptBuilder.vue';
import Popup from 'app-core/Popup.vue';
import DxButton from 'devextreme-vue/button';

export default {
	translationCategory: 'webServiceCaller.ScriptBuilder',
	components: { ScriptBuilder, Popup, DxButton },
	props: ['service', 'params'],
	data() {
		return {
			popupVisible: false,
			source: null,
			scriptInfo: this.info
		};
	},
	methods: {
		show(source, info) {
			this.source = source;
			this.scriptInfo = info;
			this.popupVisible = false;
			setImmediate(() => this.popupVisible = true);
		},
		async save() {
			let script = await this.$refs.builder.calcResults(void 0, true);
			let info = this.$refs.builder.info;

			if (__DEBUG__)
				console.debug('Save script', { script, info });

			this.$emit('save', script, info);

			this.popupVisible = false;
		}
	}
};
</script>
<style lang="scss">
	.web-services--script-builder {

	}
</style>
